var symphony = symphony || {};

;
(function () {

    symphony.hearMore = {

        submit: function () {

            $('.hearMore-error').addClass('u-hidden');

            var vals = {
                firstname: $.trim($('.hearMore-firstname-field').val()),
                lastname: $.trim($('.hearMore-lastname-field').val()),
                email: $.trim($('.hearMore-email-field').val()),
                zip: $.trim($('.hearMore-zip-field').val())
            };

            var isGroovy = true;
            if (vals.firstname == "") {
                $('#error-firstname').removeClass('u-hidden');
                isGroovy = false;
            }
            if (vals.lastname == "") {
                $('#error-lastname').removeClass('u-hidden');
                isGroovy = false;
            }
            var validEmail = true;
            var emailRegex = /^([a-zA-Z0-9_.\-''])+@([a-zA-Z0-9-_.-])+[.]+([a-zA-Z0-9]{2,4})+$/;
            if (!emailRegex.test(vals.email)) {
                validEmail = false;
            }
            if (vals.email == "" || !validEmail) {
                $('#error-email').removeClass('u-hidden');
                isGroovy = false;
            }
            if (vals.zip == "" || vals.zip.length != 5) {
                $('#error-zip').removeClass('u-hidden');
                isGroovy = false;
            }

            return isGroovy;

        }
    };


})();
